var print_summary = document.querySelector('[data-print-summary]');

if(print_summary){

    document.addEventListener("DOMContentLoaded", function () {

    print_summary.addEventListener("click", function(event){
        event.preventDefault();

        var divContents = document.querySelector(".form-summary-print-container").innerHTML;
        var a = window.open('', '', 'height=600, width=600');

        a.addEventListener("load", function() {
            a.document.title = 'Print Form Summary';
        });
        a.document.write('<html><body>');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    })

});
}